<template>
  <!-- <div> -->
  <div
    v-if="verificato && has_anagrafica"
    class="col-7 p-0 justify-content-around d-flex align-items-center menu__div line__bg"
    :style="{ 'background-image': `url(${'/svg/menuline_b.svg'})` }"
  >
    <!-- <router-link
      to="/"
      class="d-flex justify-content-center border-primary font-weight-bold text-primary p-2 mx-2"
    >
      <span class="col-3 px-0"><MedicoLogo class="icon__primary"/></span>
      <span class="ml-0">Home</span>
    </router-link>-->
    <router-link
      :to="{ name: 'Profilo' }"
      class="col-2 d-flex justify-content-center border-df-theme font-weight-bold p-2 ml-3 mr-1 bg-white"
    >
      <span class="col-3 px-0">
        <MedicoLogo class="icon__df-theme" />
      </span>
      <span class="ml-0">Profilo</span>
    </router-link>
    <router-link
      :to="{ name: 'CalendarioConsulti', params: { tipo: 'professionista' } }"
      class="col-3 d-flex justify-content-center border-df-theme font-weight-bold p-2 mx-1 bg-white"
    >
      <span class="col-3 px-0 mx-1" @click="unflagCalendario">
        <PrenotaLogo class="icon__df-theme" />
      </span>
      <span
        class="rounded-circle bg-danger unseen__icon__n text-white text-uppercase"
        v-if="nuoviConsulti > 0"
        @click="unflagCalendario"
        >{{ nuoviConsulti }}</span
      >
      <span class="ml-0" @click="unflagCalendario">Calendario</span>
    </router-link>

    <router-link
      :to="{ name: 'Messaggi' }"
      class="col-3 d-flex justify-content-center border-df-theme font-weight-bold p-2 mx-1 bg-white"
    >
      <span class="col-3 px-0" @click="unflag">
        <MessaggiLogo class="icon__df-theme" />
      </span>
      <span
        class="rounded-circle bg-danger unseen__icon__n text-white text-uppercase"
        v-if="nonletti > 0"
        @click="unflag"
        >{{ nonletti }}</span
      >
      <span class="ml-0" @click="unflag">Messaggi</span>
    </router-link>

    <a
      href="#"
      @click.prevent="logout"
      class="col-2 d-flex justify-content-center border-df-theme font-weight-bold px-1 py-2 ml-1 mr-3 bg-white"
    >
      <span class="col-3 px-0 ml-0 mr-1">
        <ExitLogo class="icon__df-theme" />
      </span>
      <span class="ml-1">Esci</span>
    </a>
  </div>
  <div
    v-else
    class="col-7 p-0 justify-content-end d-flex align-items-center menu__div line__bg"
    :style="{ 'background-image': `url(${'/svg/menuline_g.svg'})` }"
  >
    <a
      href="#"
      @click.prevent="logout"
      class="col-2 border-df-theme font-weight-bold p-2 ml-1 mr-3 bg-white"
      >Esci</a
    >
  </div>
</template>
<script>
import MedicoLogo from "@/../public/svg/medico.svg";
import MessaggiLogo from "@/../public/svg/messaggi.svg";
import PrenotaLogo from "@/../public/svg/prenota.svg";
import ExitLogo from "@/../public/svg/exit.svg";
export default {
  name: "menu-dottorfarma",
  props: ["nonletti", "verificato", "has_anagrafica", "nuoviConsulti"],
  components: { MedicoLogo, MessaggiLogo, PrenotaLogo, ExitLogo },
  computed: {
    showBack: function() {
      if (this.$route.name !== "Home") {
        return true;
      }
      return false;
    },
  },
  methods: {
    unflag() {
      // console.log("unflag", this.nonletti);
      if (this.nonletti > 0) {
        this.$emit("reset");
      }
    },
    unflagCalendario() {
      // console.log("unflag", this.nonletti);
      if (this.nuoviConsulti > 0) {
        this.$emit("reset-consulti");
      }
    },
    logout() {
      //   this.$store
      //     .dispatch("logout")
      //     .then(() => {
      //       this.$emit("logged-out");
      //     })
      //     .then(() => {
      //       this.$router.push("/");
      //     });
      this.$axios
        .post("/logout")
        .then(() => {
          // this.$emit("logging-out");
          this.$router.go();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.unseen__icon__n {
  width: 30px;
  height: 30px;
  position: absolute;
  top: -10px;
  right: -5px;
  font-size: 1.1rem;
}
.menu__div {
  width: 100%;
}
.menu__div > a {
  border-style: solid;
  border-width: 2px;
  height: 45px;
  border-radius: 0.5rem;
  width: 25%;
}
.menu__div > a span svg {
  max-height: 27px;
}
.line__bg {
  /* width: 60%; */
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  /* margin: 0.5rem auto; */
  width: 100%;
}

.router-link-exact-active,
.router-link-active {
  color: #fff !important;
  background-color: #217fb4 !important;
}
.router-link-exact-active > span > svg.icon__df-theme > .a,
.router-link-exact-active > span > svg.icon__df-theme,
.router-link-active > span > svg.icon__df-theme > .a,
.router-link-active > span > svg.icon__df-theme {
  fill: #fff !important;
  background-color: #217fb4 !important;
}
.menu__div a {
  color: #217fb4;
}
</style>
